import {
  Ban,
  CircleAlert,
  CircleCheck,
  CircleX,
  Clock,
  type LucideIcon,
  Minus,
  Pause,
  TriangleAlert,
} from 'lucide-react';

import type { CostEstimateStatus } from '../types/cost-estimate.types';

/** Chip tone per gate status (shared semantic tokens) — warning needs attention, error stopped the run. */
export const STATUS_CHIP_CLASS: Record<CostEstimateStatus, string> = {
  SKIPPED: 'bg-muted text-muted-foreground',
  BELOW_THRESHOLD: 'bg-success-50 text-success',
  ALERTED: 'bg-warning-50 text-warning',
  PENDING_APPROVAL: 'bg-warning-50 text-warning',
  APPROVED: 'bg-success-50 text-success',
  REJECTED: 'bg-error-50 text-error',
  EXPIRED: 'bg-error-50 text-error',
  ERROR: 'bg-muted text-muted-foreground',
  CANCELLED: 'bg-muted text-muted-foreground',
};

/** Leading icon per gate status, so the chip reads without relying on colour alone. */
export const STATUS_CHIP_ICON: Record<CostEstimateStatus, LucideIcon> = {
  SKIPPED: Minus,
  BELOW_THRESHOLD: CircleCheck,
  ALERTED: TriangleAlert,
  PENDING_APPROVAL: Pause,
  APPROVED: CircleCheck,
  REJECTED: CircleX,
  EXPIRED: Clock,
  ERROR: CircleAlert,
  CANCELLED: Ban,
};
